<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Geräte wahl</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" (keyup.enter)="Rotate()">
  <div class="row">
    <div class="col">
      <p>Bitte wählen sie ein Gerät aus welches Versand Werden Soll!</p>
    </div>
  </div>
  <div class="row">
    <div class="col mb-1">
      <SeriennummerSelect [(selection)]="Device" ></SeriennummerSelect>
    </div>
    <div class="row">
      <div class="col">
        <div class="btn btn-primary w-100" (click)="Rotate()" >Gerät Tauschen</div>
      </div>
      <div class="col">
        <div class="btn btn-danger w-100" (click)="modal.dismiss('Cross click')">Gerät nicht Tauschen!</div>
      </div>
    </div>
  </div>
</div>
